<template>
    <div class="">
        <h2 class="h2">{{ t('cancel.title') }}</h2>
        <p>{{ t('cancel.text') }}</p>
    </div>
</template>
<script setup>
import { useI18n } from '#imports';

defineOptions({
    name: 'CancelOrder',
});

const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            cancel: {
                title: 'Haluatko varmasti keskeyttää?',
                text: 'Täyttämäsi tiedot poistetaan etkä voi palata niihin myöhemmin.',
            },
        },
    },
});
</script>
